export default "__VITE_PUBLIC_ASSET__3bdc7308__"